import { atom } from 'jotai';

import { AddPersonWizardStep, addPersonWizardSteps } from '../AddPersonWizard/AddPersonWizard.constants';

export const addPersonPopupOpenState = atom(false);

export const addPersonPopupNodeState = atom<HTMLDialogElement | null>(null);

export const addPersonPopupStepsState = atom<AddPersonWizardStep[]>(addPersonWizardSteps);
